<template>
  <bsp-dialog :title="$t('cost.cost095')" :dialogVisible.sync="visible" @closeButton="closeDialog" width="1000px"><!-- 选择项目 -->
    <template #body v-loading="loading">
        <el-tabs v-model="activeTabName" type="border-card">
          <el-tab-pane :label="$t('cost.cost096')" name="local"><!-- 本部门项目 -->
            <project-select-tab :common-project.sync="commonProjectList" :project-type-list.sync="projectTypeList" :project-list.sync="projectList" @setProject="setProject" @projectTypeClick="projectTypeClick" />
          </el-tab-pane>
          <el-tab-pane :label="$t('cost.cost097')" name="all"><!-- 全部项目 -->
            <project-select-tab :common-project.sync="commonProjectList" :project-type-list.sync="allProjectTypeList" :project-list.sync="allProjectList" @setProject="setProject" @projectTypeClick="allProjectTypeClick" />
          </el-tab-pane>
        </el-tabs>
    </template>
  </bsp-dialog>
</template>

<script>

import { getCloudCostDetailMobileList, queryCloudCostProjectByProjectType, queryCloudCostProjectByProjectType1 } from "@/api/cost/cost";

import BspDialog from "@/components/bsp/bsp-dialog/bsp-dialog";
import ProjectSelectTab from "./ProjectSelectTab"
import { downloadFile } from '@/util/util'
import {mapGetters} from 'vuex';
import {formatDateSubstr10, formatDateSimple} from "@/util/date_format"

export default {
  name: "projectSelect",
  components: { BspDialog, ProjectSelectTab },
  props:{
    optParams: {
      type: Object,
      default: function (){
        return {
        };
      }
    }
  },
  data() {
    return {
      searchForm:{},
      searchParams: {},
      demoLoading: true,
      loadingImport: false,
      loadingBtn: false,
      visible: false,
      commonProjectList: [],
      projectTypeList : [],
      allProjectTypeList : [],
      projectList: [],
      allProjectList: [],
      projectBO : {},
      projectType:"",
      projectType1:"",
      activeTabName:"local",
    };
  },
  created() {
    if(this.optParams.type == "cost"){
      console.log("costInvoiceList==cost")
    }else{
      let that = this;
      this.demoLoading = true;
    }
  },
  mounted(){

  },
  methods: {
    init() {
      // if(this.$route.query.from){
      //   alert(this.$route.query.tdStatus);
      // }
      // var user = this.$store.state.user.userInfo;
      // this.userId = user.userId;
      this.$set(this, "commonProjectList", this.optParams.commonProjectList);
      this.$set(this, "projectTypeList", this.optParams.projectTypeList);
      this.$set(this, "allProjectTypeList", this.optParams.allProjectTypeList);

      this.$set(this.projectBO, "projectId", this.optParams.projectId);
      this.$set(this.projectBO, "projectId", this.optParams.projectId);

      console.log(this.commonProjectList, 'commonProjectList')

      if(this.optParams.projectId && this.optParams.projectType) {

        if (this.projectTypeList != null && this.projectTypeList.length > 0) {
          for (var i = 0; i < this.projectTypeList.length; i++) {
            if (this.projectTypeList[i].itemId == this.optParams.projectType) {
              this.$set(this, "projectType", this.optParams.projectType);
              this.queryCloudCostProjectByProjectType();
            }
          }
        }

        if (!this.projectType && this.allProjectTypeList != null && this.allProjectTypeList.length > 0) {
          for (var i = 0; i < this.allProjectTypeList.length; i++) {
            if (this.allProjectTypeList[i].itemId == this.optParams.projectType) {
              this.$set(this, "projectType1", this.optParams.projectType);
              this.queryCloudCostProjectByProjectType1();
              this.activeTabName = "all";
            }
          }
        }
      }

    },
    setProject(project){
      this.$emit('reload', project);
      this.clearForm();
      this.visible = false;
    },
    projectTypeClick(projectType){
      this.$set(this, "projectType", projectType.itemId);
      this.queryCloudCostProjectByProjectType();
    },
    allProjectTypeClick(projectType,index){
      this.$set(this, "projectType1", projectType.itemId);
      this.queryCloudCostProjectByProjectType1();
    },
    // submit(){
    //   if (!this.multipleSelection || this.multipleSelection.length === 0) {
    //     return this.$message.error(this.$t('homepage.txt027')) //至少选择一条数据
    //   }
    //
    //   var that = this;
    //   this.$confirm(
    //     '是否确认将所选票据添加至报销单！',
    //     '提示',
    //     {
    //       type: 'warning'
    //     }
    //   ).then(function(){
    //     //确认操作
    //     console.log("1111122")
    //     let ids =that.multipleSelection.map(item=> item.id)
    //     console.log("pickInvoice submit:" + ids);
    //     that.$emit('reload', that.multipleSelection);
    //     that.clearForm();
    //     that.visible = false;
    //   }).then((data) => {
    //     //取消操作
    //   }).catch(function (err) {
    //     //捕获异常
    //   });
    // },

    closeDialog () {
      this.visible = false;
    },
    close (){
      this.clearForm();
      this.visible = false;
    },
    clearForm(){
      this.$set(this, "commonProjectList", []);
      this.$set(this, "projectTypeList", []);
      this.$set(this, "allProjectTypeList", []);
      this.$set(this, "projectList", []);
      this.$set(this, "allProjectList", []);
      this.$set(this, "projectBO", {});
      this.$set(this, "projectType", "");
      this.$set(this, "projectType1", "");
      this.$set(this, "activeTabName", "local");
    },

    // 获取数据
    queryCloudCostProjectByProjectType() {
      this.demoLoading = true;
      let params = {
        searchParams : {
          costType: this.optParams.costType,
          projectType: this.projectType,
        }
      }

      queryCloudCostProjectByProjectType(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            this.$set(this, "projectList", result.data);

          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    queryCloudCostProjectByProjectType1() {
      this.demoLoading = true;
      let params = {
        searchParams : {
          costType: this.optParams.costType,
          projectType: this.projectType1,
        }
      }

      queryCloudCostProjectByProjectType1(params)
        .then((response) => {
          this.demoLoading = false;
          let result = response.data;
          if(result.code == '0'){
            this.$set(this, "allProjectList", result.data);

          }else{
            this.$message.success(result.msg);
          }
        })
        .catch(error => {
          this.demoLoading = false;
          console.log("error", error)
          this.$message.error(this.$t('homepage.txt024'));//请求异常！
        });

    },
    isNotBlank(str){
      if(str == null || str ==undefined || str == ''){
        return false;
      }else{
        return true;
      }
    }
  },
  destroyed(){
  },
  computed: {
    ...mapGetters(['billBatch','userInfo','dicts']),
  }
};
</script>

<style lang="scss">
  .bgBule{
    background-color: #8be9fd;
  }
</style>
